
import { Component, Vue, Watch,Prop } from "vue-property-decorator";
import Pagination from "@/components/Pagination/index.vue";
import EditPlan from "./editPlan.vue"
import {
  searchCustomer,
} from "@/api/customer";
import { getClosingOrderInfo,getNotion,closingOrderCheck,closingOrderCheckSubmit,getStateSollbackStatus,getClosureType,putClosingOrder,getRelateOrderId,postCheck,invalidClosureOrder,revertClosureOrder } from "@/api/closing-order"
@Component({
  name: "allocateInventory",
  components: {
    Pagination,
    EditPlan
  }
})
export default class extends Vue{
  @Prop({ default: null }) private id: null;
  @Prop({ default: null }) private type: null;
  private table = {
    total: 0,
    pageNumber: 1,
    pageSize: 20,
    list: [{
      customerCode: '测试填充'
    }] as any
  };
  private listParam = {};

  public updateHenganLoadingPlanDialogVisible = false;

  private packingInfoRequest = {} as any;
  private customsPackingTableData = {};

  private showCheckSuccess = false;
  private checkSuccessContent = '';
  private showCheckFail = false;
  private checkFailContent = '';
  private showEditDetail = false;
  private editDetailContent = '';
  private showWithdrawOrder = false;
  private withdrawOrder = '';
  private showCancelOrderContent = '';
  private showCancelOrder = false;

  public checkResult = '' as any

  private packingInfos = [] as any;

  private infoFields = [
    {
      label: "平仓单编号",
      prop: "code",
      key: "code"
    },
    {
      label: "平仓单生成时间",
      prop: "createdAt",
      key: "createdAt"
    },
    {
      label: "当前状态",
      prop: "stateDesc",
      key: "stateDesc"
    },
    {
      label: "平仓类型",
      prop: "typeDesc",
      key: "typeDesc",
      resetKey: {value:'name',label:'desc'},
      options: []
    },
    {
      label: "公司类型",
      prop: "company",
      key: "company",
      type: "select",
      resetKey: {value:'name',label:'desc'},
      options: [{name: 'HQ',desc: '华强'},{name: 'JR',desc: '嘉锐'}]
    },
    {
      label: "客人信息",
      prop: "customerId",
      key: "customerId",
      remote_method: this.getCustomer,
      remote: true,
      type: "select",
      resetKey: {value:'id',label:'abbreviation'},
      options: [],
      filterable: true
    },
    {
      label: "关联单据类型",
      prop: "relateType",
      key: "relateType",
      type: "select",
      resetKey: {value:'name',label:'desc'},
      disabled: true,
      options: []
    },
    {
      label: "装箱单号",
      prop: "orderId",
      key: "orderId",
      type: "select_multiple",
      collapseTags: false,
      indexKey: 'orderId',
      resetKey: {value:'orderId',label:'code'},
      options: [],
      remote: true,
      clearable: true,
      multiple: true,
      remote_method: this.getRelateOrderId
    },
    {
      label: "工厂简称",
      prop: "code",
      key: "code"
    },
    {
      label: "平仓说明",
      prop: "remark",
      key: "remark",
      type: "textarea"
    },
    {
      label: "注意事项",
      prop: "important",
      key: "important"
    }
  ] as any;
  private info = {
    code: null,
    createdAt: null,
    state: null,
    type: null,
    company: null,
    customerId: null,
    relateCode:[],
    relateType: null,
    remark: null,
    important: null,
    orderId: []
  } as any;
  private getClosureTypeList = []
  mounted () {
    this.init()
  }
  private async init() {
    await this.getCustomer()
    await this.getClosureType()
    await this.getDet()
  }
  private async getDet() {
    this.initCodelist()
    let params = {
      type :this.type
    }
    const ress:any = await getNotion(params)
    const res:any = await getClosingOrderInfo(this.id)
    this.info = Object.assign(this.info,res)
    res.relateOrders.map(item => {
      if(item.relateType === 'MAIN') {
        this.info.relateCode.push(item.code)
      }
    })
    res.relateOrders.map(item => {
      if(item.relateType === 'MAIN') {
        this.info.orderId.push(item.orderId)
      }
    })
    this.info.relateType = 'HQ_PACKING_LIST'
    this.info.important = ress.notion
    res.relateOrders.map(item => {
      if(item.relateType === "MAIN") {
        this.infoFields.find(ex => ex.key === 'orderId').options.push({
          code: item.code,
          orderId: item.orderId
        })
        this.codeList.push({
          code: item.code,
          orderId: item.orderId
        })
      }
    })
    this.packingInfos = res.packingInfos?res.packingInfos:[]
    this.info.customerId = res.relateOrders?res.relateOrders[0].customer:null
    this.infoFields[this.infoFields.findIndex(e => e.key === 'relateType')].options = [{desc:'装箱单',name:'HQ_PACKING_LIST'}]
    console.log('this.infoFields',this.infoFields)
    console.log('this.info',this.info)
  }
  private async getList() {
    // const params = {
    //   ...this.listParam,
    //   pageNumber: this.table.pageNumber,
    //   pageSize: this.table.pageSize
    // };
    // const { total, content }: any = await getInvoiceList(params);
    // this.table.total = +total;
    // this.table.list = content;
    // setTimeout(() => {
    // }, 0.3 * 1000);
  }
  public querySearch(data) {
    this.listParam = data && data !== "reset" ? data : {};
    // if (data.time && data.time.length) {
    //   this.listParam.startTime = data.time[0];
    //   this.listParam.endTime = data.time[1];
    // }
    // delete data.time;
    this.getList();
  }

  private async getCustomer(name = "") {
    const res: any = await searchCustomer({ keyword: name });
    this.infoFields[this.infoFields.findIndex(e => e.key === 'customerId')].options = res
    // this.infoFields[this.infoFields.findIndex(e => e.key === 'customerId1')].options = res
  }

  private async getClosureType() {
    const res:any = await getClosureType()
    this.infoFields[this.infoFields.findIndex(e => e.key === 'typeDesc')].options = res
    this.getClosureTypeList = res
  }

  private codeList = []

  private initCodelist() {
    this.codeList = []
    this.info = {
      code: null,
      createdAt: null,
      state: null,
      type: null,
      company: null,
      customerId: null,
      relateCode:[],
      relateType: null,
      remark: null,
      important: null,
      orderId: []
    } as any;
  }

  private async getRelateOrderId(code = null) {
    let params = {
      code: code,
      customerId: this.info.customerId,
      company: this.info.company,
      orderType: this.info.relateType
    }
    const res:any = await getRelateOrderId(params)
    let newArr = [...this.codeList,...res]
    this.infoFields[this.infoFields.findIndex(ex => ex.key === 'orderId')].options = this.Deduplication(newArr)
  }

  private Deduplication(arr){
    for(var i=0; i<arr.length; i++){
      for(var j=i+1; j<arr.length; j++){
        if(arr[i].orderId==arr[j].orderId){
          arr.splice(j,1);//第一个等同于第二个，splice方法删除第二个
          j--;
        }
      }
    }
    return arr;
  }

  private changeValue({key,value}) {
    if(key === 'type') {
      if(value) {
        if(this.getClosureTypeList.findIndex(it => it.name === value) > -1) {
          this.infoFields[this.infoFields.findIndex(x => x.key === 'relateType')].options = this.getClosureTypeList[this.getClosureTypeList.findIndex(it => it.name === value)].allowOrders
        }
      }
    }
    if(key === 'type') {
      this.info.type = value
      this.info.orderId = []
    }
    if(key === 'company') {
      this.info.company = value
      this.info.orderId = []
      this.infoFields.find(e => e.key === 'orderId').options = []
    }
    if(key === 'customerId') {
      this.info.customerId = value
      this.info.orderId = []
      this.codeList = []
      this.infoFields.find(e => e.key === 'orderId').options = []
    }
    if(key === 'relateType') {
      this.info.relateType = value
    }
  }

  private changeValueMultiple({key,value,item}) {
    if(key === 'orderId') {
      this.codeList = item
    }
  }

  private revertClosureOrder() {
    this.$confirm("确定撤回平仓单吗？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning"
    })
      .then(async () => {
        // let data = {
        //   id: this.info.id,
        //   // reason: this.withdrawOrder
        // };
        await revertClosureOrder(this.info.id).then(res => {
          this.getDet();
          this.showWithdrawOrder = false
          this.$notify({
            title: "成功",
            message: "操作成功",
            type: "success",
            duration: 2000
          });
        }).catch(err => {
          console.log(err)
        });
      })
      .catch((err) => {
        console.error(err);
      });
  }

  private invalidClosureOrder() {
    this.$confirm("确定作废平仓单吗？", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning"
    })
      .then(async () => {
        let data = {
          id: this.info.id,
          reason: this.showCancelOrderContent
        };
        await invalidClosureOrder(data).then(res => {
          this.showCancelOrder = false
          this.$notify({
            title: "成功",
            message: "操作成功",
            type: "success",
            duration: 2000
          });
          this.getDet();
        }).catch(err => {
          console.log(err)
        });
      })
      .catch((err) => {
        console.error(err);
      });
  }

  private async submitEdit() {
    let data = {
      id: this.info.id,
      company: this.info.company,
      remark: this.info.remark,
      relateOrders: this.info.orderId.map(item => {
        return {
          customer: this.info.customerId,
          orderId: item,
          type: this.info.relateType,
          relateType: 'MAIN'
        }
      })
    }
    await putClosingOrder(data).then(res => {
      this.$notify({
        title: "成功",
        message: "操作成功",
        type: "success",
        duration: 2000
      });
      this.getDet()
      this.showEditDetail = false
    }).catch(err => {
      console.log(err)
      this.showEditDetail = false
    })
  }

  editPlan() {
    this.packingInfoRequest.remark = this.info.important
    this.packingInfoRequest.customerAbbreviation = this.info.relateOrders[0].abbreviation
    console.log('this.info.relateOrders[0].customer',this.info.relateOrders[0])
    this.updateHenganLoadingPlanDialogVisible = true;
    (this.$refs.editplan as any).searchCustomsPacking()
    if(this.info.packingInfos && this.info.packingInfos.length > 0) {
      (this.$refs.editplan as any).data = this.info.packingInfos
    }
  }

  private async postCheck() {
    let data = {
      packingInfos: this.packingInfos,
      id: this.info.id,
      relateOrders: this.info.orderId.map(item => {
        return {
          customer: this.info.customerId,
          orderId: item,
          type: this.info.relateType,
          relateType: 'MAIN'
        }
      })
    }
    const loading = this.$loading({
      lock: true,
      text: 'Loading',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    });
    try {
      await postCheck(data).then(res => {
        this.$notify({
          title: "成功",
          message: "操作成功",
          type: "success",
          duration: 2000
        });
        this.getDet()
        this.checkResult = res.data?res.data:'操作成功';
        this.showCheckSuccess = true;
        loading.close();
      }).catch(error => {
        this.checkResult = error.response.data.message || error.response.data || error.message;
        loading.close();
      })
    } catch(err) {
      // console.log('返回的err',err)
      loading.close();
    }
  }

  private async closingOrderCheckSubmit() {
    let data = {
      packingInfos: this.packingInfos,
      id: this.info.id,
      relateOrders: this.info.orderId.map(item => {
        return {
          customer: this.info.customerId,
          orderId: item,
          type: this.info.relateType,
          relateType: 'MAIN'
        }
      })
    }
    const loading = this.$loading({
      lock: true,
      text: 'Loading',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    });
    await closingOrderCheckSubmit(data).then(res => {
      this.$notify({
        title: "成功",
        message: "操作成功",
        type: "success",
        duration: 2000
      });
      this.getDet()
      this.showCheckSuccess = false;
      loading.close();
    }).catch(err => {
      console.log(err)
    })
  }

  private async searchCustomer(name = "") {
    // const res: any = await searchCustomer({ keyword: name });
    // this.searchForm[0].options = res;
  }
}
